<!-- Component to show:
    Sensor List - By Default
    Sensor Messages - Optional
    Sensor Message details - Optional

  Props:
      1. rowsPerPage: Number of rows that must be shown on each page.
      2. items: Sensor List that is going to be shown on Sensor table.
      3. fields: Fields that are visible for sensors
      4. busy: Flag to show loading icon on Sensor list table
      5. fieldsSensorMsgs: If 'fields' contains "messages" it means that this component must show sensor messages as well
                            so this 'prop' indicates visible fields for sensor messages
      6. retrieveSensorMgs: If messages are visible in this component you need to pass a function to retrieve sensor messages.
      7. fieldsMsgsDetails: If 'fieldsSensorMsgs' contains "detail" it means that this component must show sensor message detail
                            so this 'prop' indicates visible fields for sensor message details

-->

<template>
  <div class="container-fluid mt-4">

    <div v-if="showSensorList">
      <b-table id="sensors-table"
               :items="items"
               :fields="fields"
               :busy="busy"
               :current-page="pagination.current_page"
               :per-page="rowsPerPage"
               striped
               show-empty>

        <template v-slot:cell(messages)="item">
          <b-link @click="seeSensorMgs(item.item)"> See Messages </b-link>
          <!--| <b-link @click="getDownloadSensorMsgs(item.item.podid)"> Download </b-link>-->
        </template>

        <template slot="table-busy">
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong style="margin-left:20px">Loading...</strong>
          </div>
        </template>
      </b-table>

      <b-row v-if="items && items.length > rowsPerPage">
        <b-col>
          <b-pagination v-model="pagination.current_page"
                        :total-rows="items ? items.length : 0"
                        :per-page="rowsPerPage"
                        align="center">
          </b-pagination>
        </b-col>
      </b-row>

    </div>

    <div v-else>
      <k-sensor-msg-list :sensor="sensorSelected"
                         :items="messages.items"
                         :fields="fieldsSensorMsgs"
                         :busy="messages.loading"
                         :fields-msgs-details="fieldsMsgsDetails"
                         :rows-per-page="rowsPerPage"
                         :show-back-button="true"
                         @fnShowSensorList="fnShowSensorList" />
    </div>


  </div>
</template>

<script>

    import KSensorMsgList from './SensorMsgList'

    export default {
        name: 'k-sensor-list',

        components: { KSensorMsgList },

        props: {
            rowsPerPage: { type: Number, default: 20, required: false },

            items: { type: Array, default: [], required: true },
            fields: { type: Array, default: [], required: true },
            busy: { type: Boolean, default: false, required: true },

            fieldsSensorMsgs: { type: Array, default: [], required: false },
            retrieveSensorMgs: { type: Function, required: false },
            downloadSensorMgs: { type: Function, required: false },

            fieldsMsgsDetails: { type: Array, default: [], required: false },

        },

        data() {
            return {

                messages: {
                    items: [],
                    loading: false
                },

                showSensorList: true,

                sensorSelected: {},

                pagination: {
                    current_page: 1
                }

            }
        },

        methods: {

            async seeSensorMgs(sensor) {
                this.sensorSelected = sensor;
                this.showSensorList = false;

                this.messages.loading = true;
                this.messages.items = [];
                this.messages.items = await this.retrieveSensorMgs(sensor);
                this.messages.loading = false;

                if (window.pageYOffset > 250) {
                    window.scrollTo({ top: 250 });
                }

            },

            fnShowSensorList(show) {
                this.showSensorList = show;
            },
            async getDownloadSensorMsgs(podid){
                await this.downloadSensorMgs(podid);
            }
        },

        filters: {},

        watch: {}
    }

</script>
